import { Controller } from "@hotwired/stimulus"

// The confirmation's Share (TMS-1809): the device's share sheet where there is one, else the
// message and the donation page's link copied. Never the gift's amount.
export default class extends Controller {
  static targets = ["label"]
  static values = { url: String, text: String }

  async share() {
    const data = { title: "The Menopause Society", text: this.textValue, url: this.urlValue }

    if (navigator.share) {
      try {
        await navigator.share(data)
        return
      } catch (error) {
        if (error.name === "AbortError") return
      }
    }

    try {
      await navigator.clipboard.writeText(`${this.textValue} ${this.urlValue}`)
      this.flash("Link copied")
    } catch {
      this.flash("Couldn't copy")
    }
  }

  flash(message) {
    if (!this.hasLabelTarget) return
    this.labelTarget.textContent = message
    clearTimeout(this.timer)
    this.timer = setTimeout(() => { this.labelTarget.textContent = "Share" }, 2500)
  }
}
